import { cn } from "@/lib/utils";
import type { ComponentType, SVGProps } from "react";

interface EmptyStateProps {
  message: string;
  className?: string;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
}

export function EmptyState({ message, className, icon: Icon }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "text-sm text-muted-foreground py-12 text-center flex flex-col items-center gap-3",
        className
      )}
    >
      {Icon && <Icon className="h-10 w-10 text-muted-foreground/50" />}
      {message}
    </div>
  );
}
